import React, { FC } from 'react'

import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { CustomModal } from '../../components/Modal'
import { useAppDispatch } from '../../store/hooks'

import { disableMassFill, enableMassFill } from './TradingLogSlice'
import { OverrideQuestionnaire } from './types'

export const OverrideQuestionnaireModal: FC<OverrideQuestionnaire> = ({ open, onClose }) => {
  const dispatch = useAppDispatch()

  const { t } = useTranslation()

  const handleClose = () => {
    onClose()
    dispatch(disableMassFill())
  }

  const handleSubmit = () => {
    dispatch(enableMassFill())
    onClose()
  }

  return (
    <CustomModal
      open={open}
      onClose={handleClose}
      onSubmit={handleSubmit}
      submitButtonText={
        t('tradingLogPage.overrideQuestionnaire.actions.override', 'Override') || ''
      }
      title={t('tradingLogPage.overrideQuestionnaire.title', 'Override Questionnaire')}
      submitButtonProps={{ color: 'error' }}
    >
      <Typography variant="body1" fontWeight={500}>
        {t(
          'tradingLogPage.overrideQuestionnaire.warning',
          'You have selected trades with filled or partially filled analytical questionnaires. Continuing will override the existing data for these trades. Are you sure you want to proceed?',
        )}
      </Typography>
    </CustomModal>
  )
}
